export default {_name:'grid.form.section',module:'Card/Form',view:'Element/Section',options:{component:'section',classes:['end'],md:12,ms:12}}